import { Component, Input } from '@angular/core';

@Component({
  selector: 'check-circle',
  standalone: false,
  template: "<i class=\"far\" [ngClass]=\"{'fa-check-circle': active, 'fa-circle': !active }\"></i>"
})

export class CheckCircle {
  @Input() active: boolean;
}
